import React from 'react';
interface WatchtowerMarkProps {
  className?: string;
  /** Draws the lit beam. Turn off for one-colour print and tiny sizes. */
  beam?: boolean;
  /** Overrides the beam colour; defaults to the brand sun. */
  beamClassName?: string;
}

/**
 * Watchtower mark: a squat lighthouse throwing a lit beam to the right.
 * The tower is currentColor so it inverts cleanly on the shell; the beam
 * is a separate fill so it can be dropped where it would muddy the shape.
 */
export function WatchtowerMark({
  className = '',
  beam = true,
  beamClassName = 'text-sun'
}: WatchtowerMarkProps) {
  return <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true" focusable="false" data-id="element-458" data-mp="9mkdqkp1u545">
      {beam && <g className={beamClassName} fill="currentColor" data-id="element-459" data-mp="efnaf1p4huok">
          {/* lantern light */}
          <path d="M8 8.4h5.1v4h-5.1z" data-id="element-460" data-mp="3d3aqrjj1tifc" />
          {/* projected beam */}
          <path d="M13.1 8.5 31 3.4v10.2L13.1 12.4z" data-id="element-461" data-mp="3i1ch8pit0k0u" />
        </g>}

      {/* finial and roof */}
      <circle cx="10.5" cy="2.3" r="0.9" fill="currentColor" data-id="element-462" data-mp="kng5usg77mtn" />
      <path d="M10.5 3.2v1.1" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" data-id="element-463" data-mp="fp67k8z6g63t" />
      <path d="M10.5 4.2 15.6 8.4H5.4z" fill="currentColor" data-id="element-464" data-mp="axn1abeh47yw" />

      {/* lantern frame, drawn as posts so the light reads through */}
      {beam ? <path d="M7.4 8.4h1.2v4h-1.2zm5.1 0h1.2v4h-1.2z" fill="currentColor" data-id="element-465" data-mp="1y9op9v1z39y" /> : <path d="M7.4 8.4h6.2v4H7.4z" fill="currentColor" data-id="element-466" data-mp="3t41da4t6m7un" />}

      {/* gallery */}
      <path d="M5.9 12.4h9.2v2H5.9z" fill="currentColor" data-id="element-467" data-mp="3o4y9enoxu7o9" />

      {/* tapered body with a doorway punched out */}
      <path fillRule="evenodd" clipRule="evenodd" d="M7.5 14.8h6l1.4 11.4H6.1zm2.05 5.9a1.15 1.15 0 0 1 2.3 0v5.5h-2.3z" fill="currentColor" data-id="element-468" data-mp="3k4o5rhombtck" />
      <path d="M7.2 17.6h6.6M6.8 20.5h7.4" stroke="currentColor" strokeWidth="0.85" opacity="0.26" data-id="element-469" data-mp="1icsxzd5hg8zm" />

      {/* base */}
      <path d="M3.6 26.4h13.8a.75.75 0 0 1 .75.75v1.7a.75.75 0 0 1-.75.75H3.6a.75.75 0 0 1-.75-.75v-1.7a.75.75 0 0 1 .75-.75z" fill="currentColor" data-id="element-470" data-mp="3btxjlcqzpjms" />
    </svg>;
}